import React from 'react';
import Relay from 'react-relay';
import { style, $, keyframes } from 'glamor';
import LogoutButton from 'depop/root/containers/components/LogoutButton';
import Link from 'depop/components/Link';

import FullScreen from 'depop/components/layout/FullScreen';

import { FormattedMessage } from 'react-intl';

const INSTAGRAM_LINK = 'https://instagram.com/depop/';
const TWITTER_LINK = 'https://twitter.com/depop/';
const FACEBOOK_LINK = 'https://facebook.com/depop';

const menuItemStyles = {
  fontSize: '20px',
  fontWeight: 'bold',
  margin: '1em 0',
};

const rootStyleBasic = {
  position: 'fixed',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: '20',
  width: '100vw',
  height: '100%',
  padding: '0 20px 20px',
  backgroundColor: 'white',
};

const inFromRight = keyframes({
  'from': { transform: 'translateX(100vw)' },
  'to': { transform: 'translateX(0)' },
});

class FullPageNav extends React.Component {
  props: {
    viewer: Object,
    toggle: () => void,
    isExpanded: Boolean,
    toggleDownloadAppModal: () => void,
  };

  render() {
    const { viewer, toggle, isExpanded, toggleDownloadAppModal } = this.props;
    const { currentUser } = viewer;

    const rootStyle = isExpanded
    ? {
      ...rootStyleBasic,
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      backgroundColor: 'white',
      animationName: inFromRight,
      animationDuration: '.15s',
      animationFillMode: 'forwards',
      animationTimingFunction: 'ease-in-out',
    }
    : rootStyleBasic;

    return (
      <FullScreen>
        <div {...style(rootStyle)} onClick={toggle}>
          <ul {...style({
            width: '100%',
            margin: '-20px auto 0',
            listStyle: 'none',
          })}>
            {currentUser &&
              <li
                {...style(menuItemStyles)}>
                <Link
                  style={{color: 'inherit', textDecoration: 'none'}}
                  to={{pathname: `/${currentUser.username}`, state: {userId: currentUser.publicId}}}>
                  <FormattedMessage
                    id="app.profileLabel"
                    description="Displayed on a link to a user's own profile"
                    defaultMessage="Profile" />
                </Link></li>}
            {!currentUser && <li
              {...style(menuItemStyles)}
              {...$('a', { color: 'inherit', textDecoration: 'none' })}
              {...$('a:hover', { textDecoration: 'underline' })}>
              <span style={{cursor: 'pointer'}} onClick={toggleDownloadAppModal}>
                <FormattedMessage
                  id="app.downloadLabel"
                  description="Download Label"
                  defaultMessage="Download App"
                />
              </span>
            </li>}
            <li {...style(menuItemStyles)}>
              <Link
                style={{color: 'inherit', textDecoration: 'none'}}
                to={{pathname: '/about/'}}>
                <FormattedMessage
                  id="app.aboutLabel"
                  description="About Label"
                  defaultMessage="About"
                />
              </Link></li>
            <li {...style(menuItemStyles)}>
              <Link
                style={{color: 'inherit', textDecoration: 'none'}}
                to={{pathname: '/about/jobs/'}}>
                <FormattedMessage
                  id="app.jobsLabel"
                  description="Jobs Label"
                  defaultMessage="Jobs"
                />
              </Link></li>
            <li {...style(menuItemStyles)}>
              <a rel="noopener"
                target="_blank"
                href="http://blog.depop.com/"
                {...style({color: 'inherit', textDecoration: 'none'})}>
                <FormattedMessage
                  id="app.blogLabel"
                  description="Blog Label"
                  defaultMessage="Blog"
                />
              </a>
            </li>
            <li {...style(menuItemStyles)}>
              <a
                rel="noopener"
                target="_blank"
                href="http://help.depop.com/"
                {...style({color: 'inherit', textDecoration: 'none'})}>
                <FormattedMessage
                  id="app.supportLabel"
                  description="Support Label"
                  defaultMessage="Support"
                />
              </a>
            </li>
            <li {...style(menuItemStyles)}>
              <a
                rel="noopener"
                target="_blank"
                href={INSTAGRAM_LINK}
                {...style({color: 'inherit', textDecoration: 'none'})}
                >Instagram</a>
            </li>
            <li {...style(menuItemStyles)}>
              <a
                rel="noopener"
                target="_blank"
                href={TWITTER_LINK}
                {...style({color: 'inherit', textDecoration: 'none'})}
                >Twitter</a>
            </li>
            <li {...style(menuItemStyles)}>
              <a
                rel="noopener"
                target="_blank"
                href={FACEBOOK_LINK}
                {...style({color: 'inherit', textDecoration: 'none'})}
                >Facebook</a></li>
            {currentUser && <li {...style(menuItemStyles)}><LogoutButton /></li>}
          </ul>
        </div>
      </FullScreen>
    );
  }
}

export default Relay.createContainer(FullPageNav, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        currentUser {
          publicId
          username
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/layout/menu/FullPageNav.js